/* ab-bala-regua.js — TEMA BALA (cópia 191310627112) régua PRÓPRIA, 02/11. Os cards já vêm prontos do servidor (snippets/ab-bala-regua.liquid).
   Aqui só: escolher o card, mandar N unidades (ou o produto-kit) no MESMO formulário do tema e marcar _origem=bala + _opcao=Nun|kit.
   Não usa o widget do Kaching. Preço do kit no carrinho/Yampi = desconto automático (hoje o do Kaching, que vale pela quantidade; depois o nosso). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var RG = $('[data-bala-rg]'); if (!RG || window.__balaRg) return; window.__balaRg = 1;
  var V = RG.getAttribute('data-v'), ESC = null;
  var forms = function () { return $$('form[action*="/cart/add"]').filter(function (f) { var i = f.querySelector('[name="id"]'); return i && String(i.value) === V; }); };
  var op = function (id) { return $('[data-abv-op="' + id + '"]', RG); };
  function escolhe(id) {
    var b = op(id); if (!b) return;
    ESC = { id: id, n: +b.getAttribute('data-n') || 1, kit: b.hasAttribute('data-kit'), v: b.getAttribute('data-v'), total: +b.getAttribute('data-total') || 0 };
    $$('[data-abv-op]', RG).forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
    document.dispatchEvent(new CustomEvent('abv:regua', { detail: { n: ESC.n, kit: ESC.kit, total: ESC.total } }));
  }
  var ini = $('[aria-checked="true"]', RG) || $('[data-abv-op]', RG); if (ini) escolhe(ini.getAttribute('data-abv-op'));
  RG.addEventListener('click', function (e) { var b = e.target.closest('[data-abv-op]'); if (b) escolhe(b.getAttribute('data-abv-op')); });
  RG.addEventListener('keydown', function (e) {
    if (['ArrowRight', 'ArrowLeft'].indexOf(e.key) < 0) return; var L = $$('[data-abv-op]', RG), i = L.indexOf(document.activeElement); if (i < 0) return;
    var j = (i + (e.key === 'ArrowRight' ? 1 : L.length - 1)) % L.length; L[j].focus(); escolhe(L[j].getAttribute('data-abv-op')); e.preventDefault();
  });
  // no envio (fase de captura, antes do tema montar o FormData): id/quantidade/marca; desfaz logo depois
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!ESC || forms().indexOf(f) < 0) return;
    var desfaz = [], poe = function (nome, valor) {
      var i = f.elements[nome]; if (i && i.length && !i.tagName) i = i[0];
      if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = nome; f.appendChild(i); desfaz.push(function () { i.remove(); }); }
      else { var a = i.value; desfaz.push(function () { i.value = a; }); }
      i.value = valor;
    };
    var kI = f.querySelector('input[name="properties[__kaching_bundles]"]'); if (kI) { kI.disabled = true; desfaz.push(function () { kI.disabled = false; }); }
    if (ESC.kit) { poe('id', ESC.v); poe('quantity', '1'); } else poe('quantity', String(ESC.n));
    poe('properties[_origem]', 'bala'); poe('properties[_opcao]', ESC.kit ? 'kit' : ESC.n + 'un');
    setTimeout(function () { desfaz.reverse().forEach(function (fn) { fn(); }); }, 0);
  }, true);
  // "Escolha a sua rotina" (fim da PDP): mesmos cards com botão "Quero…"
  var OF = $('[data-abv-ofs-l]');
  if (OF) {
    OF.innerHTML = $$('[data-abv-op]', RG).map(function (b) {
      var id = b.getAttribute('data-abv-op'), n = +b.getAttribute('data-n'), kit = b.hasAttribute('data-kit'), top = b.classList.contains('abv-rg-top');
      return '<div class="abv-rg-o' + (top ? ' abv-rg-top' : '') + '">' + b.innerHTML + '<button type="button" class="abv-bt' + (top ? '' : ' abv-bt-cl') + '" data-abv-quero="' + id + '">Quero ' + (kit ? 'o kit' : n > 1 ? 'os ' + n : 'este') + '</button></div>';
    }).join('');
    var sec = $('[data-abv-ofs]'); if (sec) sec.hidden = false;
    OF.addEventListener('click', function (e) {
      var b = e.target.closest('[data-abv-quero]'); if (!b) return;
      escolhe(b.getAttribute('data-abv-quero'));
      var f = forms()[0], bt = f && (f.querySelector('[type=submit][name=add]') || f.querySelector('[type=submit]'));
      if (bt) bt.click(); else if (f) f.requestSubmit();
    });
  }
  if (window.performance && performance.mark) try { performance.mark('abv-regua'); } catch (e) {}
})();
